export enum EGalleryFilesChanged {

  NoFile = 1,
  OneFile,
  SomeFiles
}